export default {
  data() {
    return {
      allCallTag: [],
    };
  },
  methods: {
    getListOfCallTagForMissionResultFunction: function (type) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getListOfMissionCallTagsResult').then(() => {
        if (this.$store.state.callTagModule.successFlag) {

          // this.endCallTagsList = this.$store.state.callTagModule.missionResultTags;
          this.endCallTagsList = Array.isArray(this.$store.state.callTagModule?.missionResultTags)
            ? this.$store.state.callTagModule?.missionResultTags
            : [];

          if (this.formLoad) {
            if (type == 'hand') {
              this.endCallTagsList = this.endCallTagsList.filter((c) => c.id == 2);
            }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callTagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfCallTagForMissionResultFunction(type);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callTagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfCallTagForMissionResultFunction(type);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllCallTagFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllCallTag').then(() => {
        if (this.$store.state.callTagModule.successFlag) {
          this.allCallTag = this.$store.state.callTagModule.allCallTag;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callTagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllCallTagFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callTagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllCallTagFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.callTagModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
